export function validateTag(data: Record<string, unknown>): string[] {
    const errors: string[] = [];

    if (!data.label) {
        errors.push('Libellé requis.');
    }

    if (!data.agencyId) {
        errors.push('Agence requise.');
    }

    return errors;
}
